import { Component, OnInit, HostListener, Input, Output, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CardPreviewService, IWeblinkIcons, iconsWeblink, IBrandcardResult } from '@app/components/card-preview'
import { CompanyService } from '@app/services/Company/company.service'

@Component({
  selector: 'app-weblink-frame-company-info',
  templateUrl: './weblink-frame-company-info.component.html',
  styleUrls: ['./weblink-frame-company-info.component.scss']
})
export class WeblinkModalAnimateComponent implements OnInit {
  @Input() mediaData: IBrandcardResult
  @Output() setModalDisplay = new EventEmitter<boolean>()

  isModalDisplay: boolean
  isWindowInnerHeightGreater800 = true
  weblinkIcons: IWeblinkIcons = iconsWeblink
  company_phone: number
  companyInfoDetailHeight: number
  ctos_pdf: string
  constructor(
    private companyService: CompanyService,
    private cardPreviewService: CardPreviewService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.calculateHigh()
    this.listenToSubscriber()
    this.getCtosApp()
  }

  getCtosApp() {
    /*this.companyService.currentCtosPdf$.subscribe((pdf: any) => {
      if (pdf.status === 'OK')
        this.ctos_pdf = atob(pdf.data)
    })*/
    this.getCtosPdf();
  }


  getCtosPdf() {
    const company = this.companyService.getCurrentCompany()
    
    if (company) {
      const companyId = company.id;
      const ctosstatus = company.ctos;
      if (ctosstatus && ctosstatus.status == 1) {
        
        /*this.companyService.ctosPdf(companyId).subscribe((pdf: any) => {
          this.companyService.setCtosPdfUrl(pdf)
          this.ctos_pdf = atob(pdf.data)
        })*/
      }
    }
  }

  openCtosPdf() {
    var byteCharacters = this.ctos_pdf
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cardPreviewService.getWindow().innerHeight <= 800) {
        this.isWindowInnerHeightGreater800 = false
      } else {
        this.isWindowInnerHeightGreater800 = true
      }

    }
  }

  calculateHigh() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cardPreviewService.getWindow().innerHeight <= 800) {
        this.isWindowInnerHeightGreater800 = false
      } else {
        this.isWindowInnerHeightGreater800 = true
      }
    }
  }

  listenToSubscriber() {
    this.cardPreviewService.currentShowModalCardInfo.subscribe((status: boolean) => {
      this.isModalDisplay = status
    })
  }

  goBackToMain() {
    this.setModalDisplay.emit(false)
    this.cardPreviewService.setScreen2(false)
    this.cardPreviewService.setShowAllActions(false)
    this.cardPreviewService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'open card info'})
  }

  triggerCardDetail(event: string) {
    let url = ''
    if (event === 'ctos') {
      // Malaysia Company
      const company_name = this.mediaData.co_regname.replace(/\s/g, '').toUpperCase()
      if (this.mediaData.co_country === 'MY' && this.mediaData.co_regno) {
        const reg_no = this.mediaData.co_regno
        url = `https://www.ctoscredit.com.my/business/${company_name}-${reg_no}`
      }
      if (this.mediaData.co_country !== 'MY' && this.mediaData.co_regno) {
        const reg_no = this.mediaData.co_regno
        url = `https://www.ctoscredit.com.my/search/company/details/${company_name}/${reg_no}`
      }
      if (!this.mediaData.co_regno) {
        const name = this.mediaData.name
        const country_code = this.mediaData.co_country
        url = `https://www.ctoscredit.com.my/search/company/results/${name}/${country_code}`
      }
    } else if (event === 'address') {
      url = this.mediaData.social_links.googlemap
    } else if (event === 'website') {
      url = this.mediaData.social_links.www
    }

    if (url !== '')
      if (isPlatformBrowser(this.platformId)) {
        this.cardPreviewService.getWindow().open(url, '_blank')
      }
  }

}
